import { useGameStore, SCREEN } from "@/stores/gameStore";
import { useMatchStore } from "@/stores/matchStore";
import { MATCH } from "@/constants/testIds";
import { Play, LogOut } from "lucide-react";

export default function PauseMenu({ onResume }) {
    const goto = useGameStore((s) => s.goto);

    return (
        <div
            data-testid={MATCH.pauseMenu}
            className="fixed inset-0 z-30 flex items-center justify-center bg-black/70 backdrop-blur-xl axis-fade-in"
        >
            <div className="axis-glass axis-cut p-10 min-w-[380px]">
                <div className="text-center mb-6">
                    <div className="axis-mono text-[10px] tracking-[0.5em] text-cyan-300/80">SYSTEM</div>
                    <div className="axis-heading text-4xl tracking-[0.4em] axis-metallic">PAUSED</div>
                </div>

                <div className="flex flex-col gap-3">
                    <button
                        data-testid={MATCH.resume}
                        onClick={onResume}
                        className="axis-btn axis-btn-primary axis-cut-sm py-3 flex items-center justify-center gap-2"
                    >
                        <Play size={16} /> Resume
                    </button>
                    <button
                        data-testid={MATCH.quit}
                        onClick={() => {
                            useMatchStore.setState({ phase: "match_end", winner: "enemy" });
                            goto(SCREEN.MENU);
                        }}
                        className="axis-btn axis-btn-ghost axis-cut-sm py-3 flex items-center justify-center gap-2"
                    >
                        <LogOut size={16} /> Quit Match
                    </button>
                </div>
            </div>
        </div>
    );
}
